<nav
  class="navbar navbar-expand-lg"
  [class.navbar-light]="!isDarkMode()"
  [class.navbar-dark]="isDarkMode()"
  [attr.data-bs-theme]="currentTheme()"
>
  <div class="container-fluid">
    <a class="navbar-brand text-white" href="https://www.clareobio.com">clareo</a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link text-white" [routerLinkActive]="['active']" routerLink="/home">Home</a>
        </li>
      </ul>
      <ul class="navbar-nav">
        <app-theme-picker></app-theme-picker>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle text-white"
            href="#"
            id="userDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <fa-icon [icon]="faUser"></fa-icon>
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
            @if (credentialsService.credentials()) {
              <li>
                <span class="dropdown-item-text">Logged in as {{ credentialsService.email() }}</span>
              </li>
            }
            @if (credentialsService.credentials() && credentialsService.admin()) {
              <li>
                <a class="dropdown-item" (click)="refreshData()">
                  <fa-icon [icon]="faSync" class="me-2"></fa-icon>
                  Refresh Data
                </a>
              </li>
            }
            <li>
              @if (!credentialsService.credentials()) {
                <a class="dropdown-item" routerLink="/login">Login</a>
              }
            </li>
            <li>
              <hr class="dropdown-divider" />
            </li>
            <li>
              @if (credentialsService.credentials()) {
                <a class="dropdown-item" (click)="logout()">Logout</a>
              }
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>

<!-- Refresh Data Modal -->
<app-refresh-data-modal></app-refresh-data-modal>
